var $d72adf5b20573e34$exports = {};
$d72adf5b20573e34$exports = {
  "decrease": function decrease(args) {
    return "Diminuer ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Augmenter ".concat(args.fieldLabel);
  },
  "numberField": "Champ de nombre"
};
export { $d72adf5b20573e34$exports as default };